import dayjs, { type Dayjs } from 'dayjs';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);
dayjs.extend(localizedFormat);
dayjs.extend(advancedFormat);
dayjs.extend(timezone);

// NOTE: This is a copy of the formatDate function from the shared library (libs/services/shared/src/utils/date.ts)
// We are copying it here to avoid dependency on the shared library to reduce bundle size of DS
export const formatDate = (
  date?: string | number | Date | Dayjs,
  formattedDate?: string,
  useOnlyUTC = false
): string => {
  if (!date) return '';

  let dateObj = typeof date === 'number' ? dayjs.unix(date) : dayjs(date);
  if (isNaN(dateObj.toDate().getTime())) return '';
  // adding this check to ignore DB default date (0001-01-01T00:00:00Z)
  if (dateObj.year() < 1900) return '';

  if (useOnlyUTC) dateObj = dateObj.utc();

  return dateObj.format(formattedDate);
};

export const getTodaysDate = (formattedDate: string) => dayjs().format(formattedDate);

/**
 * Returns timezone information for the specified IANA timezone.
 *
 * @param timezone - Optional IANA timezone string (e.g., 'America/New_York').
 * @returns An object containing:
 *   - `shortText`: Short timezone abbreviation (e.g., 'EST'). Empty string if invalid.
 *   - `longText`: Full timezone name (e.g., 'Eastern Standard Time'). Empty string if invalid.
 *   - `getDate`: Function returning the current Dayjs object in the specified timezone.
 */
export const getTimezoneInfo = (timezone?: string) => {
  try {
    const now = dayjs().tz(timezone);
    return {
      shortText: now.format('z'),
      longText: now.format('zzz'),
      getDate: () => dayjs().tz(timezone),
    };
  } catch (error) {
    console.error(`Error getting timezone info: ${error}`);
    return {
      shortText: '',
      longText: '',
      getDate: () => dayjs(),
    };
  }
};
